module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploader"
  }, [_c('input', {
    staticClass: "uploader__file",
    attrs: {
      "type": "file",
      "id": "file_uploader",
      "accept": _vm.accept
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.files)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileName),
      expression: "fileName"
    }],
    staticClass: "uploader__filename"
  }, [_vm._v("\n    " + _vm._s(_vm.fileName) + "\n  ")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "uploader__add",
    attrs: {
      "for": "file_uploader"
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileName),
      expression: "fileName"
    }],
    staticClass: "uploader__remove",
    on: {
      "click": function($event) {
        _vm.deleteFile()
      }
    }
  }, [_vm._v("remove")])]), _vm._v(" "), _c('div', {
    staticClass: "uploader__desc"
  }, [_vm._v(".Zip file only, 25MB max")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10cfd65f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/components/digital_uploader.vue
// module id = 1613
// module chunks = 180